'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultWatchOptions = undefined;

var _lodash = require('lodash.merge');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.pick');

var _lodash4 = _interopRequireDefault(_lodash3);

var _getOrCall = require('../getOrCall');

var _getOrCall2 = _interopRequireDefault(_getOrCall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultWatchOptions = exports.defaultWatchOptions = {
    fetchPolicy: 'network-only',
    pollInterval: 2000
};

var knownApolloOptions = ['fetchPolicy', 'metadata', 'noFetch', 'notifyOnNetworkStatusChange', 'pollInterval', 'query', 'reducer', 'returnPartialData', 'variables'];

/**
 * Get options for calling ApolloClient.watchQuery.
 * @param apolloWatchOptions {Object} Options supplied by user
 * @param action {Object} Action from admin-on-rest
 */

exports.default = function (apolloWatchOptions, _ref) {
    var _ref$meta = _ref.meta,
        fetch = _ref$meta.fetch,
        resource = _ref$meta.resource;

    var options = [];
    var tmpOptions = (0, _getOrCall2.default)(apolloWatchOptions, resource, fetch);
    options.push(tmpOptions);

    if (tmpOptions) {
        options.push(tmpOptions);
        tmpOptions = (0, _getOrCall2.default)(tmpOptions[resource], fetch);

        if (tmpOptions) {
            options.push(tmpOptions);
            tmpOptions = (0, _getOrCall2.default)(tmpOptions[fetch]);

            if (tmpOptions) {
                options.push(tmpOptions);
            }
        }
    }

    return options.reduce(function (final, opts) {
        return (0, _lodash2.default)({}, final, (0, _lodash4.default)(opts, knownApolloOptions));
    }, defaultWatchOptions);
};


//////////////////
// WEBPACK FOOTER
// ./~/aor-simple-graphql-client/lib/realtime/getWatchOptionsForQuery.js
// module id = 942
// module chunks = 0